// extracted by mini-css-extract-plugin
export default {"wrapper":"CancelRequest_wrapper__sPu9H","up":"CancelRequest_up__F4sDX","content":"CancelRequest_content__5ps84","buttons":"CancelRequest_buttons__eGrJr"};